import { render, staticRenderFns } from "./GroupAdminPages.vue?vue&type=template&id=dae4f5bc&scoped=true"
import script from "./GroupAdminPages.vue?vue&type=script&lang=js"
export * from "./GroupAdminPages.vue?vue&type=script&lang=js"
import style0 from "./GroupAdminPages.vue?vue&type=style&index=0&id=dae4f5bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae4f5bc",
  null
  
)

export default component.exports